import React, {Fragment} from 'react'
import styles from './UpsellFooter.scss'
import {contentLabel} from 'lib/styleguide/base.scss'

import routePlanning from './images/route-planning.png'
import routePlanning2x from './images/route-planning@2x.png'
import routePlanning3x from './images/route-planning@3x.png'

import customCues from './images/custom-cues.png'
import customCues2x from './images/custom-cues@2x.png'
import customCues3x from './images/custom-cues@3x.png'

import rideCleanup from './images/ride-clean-up.png'
import rideCleanup2x from './images/ride-clean-up@2x.png'
import rideCleanup3x from './images/ride-clean-up@3x.png'

import eTFeature from './images/et-feature.png'
import eTFeature2x from './images/et-feature@2x.png'
import eTFeature3x from './images/et-feature@3x.png'

import voiceFeature from './images/voice-feature.png'
import voiceFeature2x from './images/voice-feature@2x.png'
import voiceFeature3x from './images/voice-feature@3x.png'

import pdfFeature from './images/pdf-feature.png'
import pdfFeature2x from './images/pdf-feature@2x.png'
import pdfFeature3x from './images/pdf-feature@3x.png'

const topContent = {
  premium: <Fragment>
    <div className={contentLabel}>why premium</div>
    <h3 className={styles.footerHeader}>Powerful tools for planning high quality routes and managing your ride data in detail or in bulk.</h3>
  </Fragment>,
  basic: <Fragment>
    <div className={contentLabel}>why basic</div>
    <h3 className={styles.footerHeader}>Signature tools for navigating and downloading routes and sharing rides.</h3>
  </Fragment>
}

const leftContent = {
  premium: <Fragment>
    <img
      src={routePlanning}
      srcSet={`${routePlanning} 1x, ${routePlanning2x} 2x, ${routePlanning3x} 3x`}
      alt='advanced route planning' />
    <h4>Advanced Route Planning</h4>
    <p>Turn recorded rides into a route with a cuesheet. Split, combine, and reverse routes. Display multiple routes while planning so you can easily trace portions of other routes.</p>
  </Fragment>,
  basic: <Fragment>
    <img
      src={eTFeature}
      srcSet={`${eTFeature} 1x, ${eTFeature2x} 2x, ${eTFeature3x} 3x`}
      alt='estimated time' />
    <h4>Estimated Time</h4>
    <p>Know how long a ride is going to take with personalized estimated time for every route you create or find.</p>
  </Fragment>
}

const centerContent = {
  premium: <Fragment>
    <img
      src={customCues}
      srcSet={`${customCues} 1x, ${customCues2x} 2x, ${customCues3x} 3x`}
      alt='custom cues' />
    <h4>Custom Cues and Points of Interest</h4>
    <p>Personalize your routes with custom cues, and add points of interest to show route features like food, lodging, viewpoints, or water sources.</p>
  </Fragment>,
  basic: <Fragment>
    <img
      src={voiceFeature}
      srcSet={`${voiceFeature} 1x, ${voiceFeature2x} 2x, ${voiceFeature3x} 3x`}
      alt='voice navigation' />
    <h4>Voice Navigation</h4>
    <p>Use the Ride with GPS app to get spoken turn-by-turn directions for your routes. Keep your head up, and enjoy the ride.</p>
  </Fragment>
}

const rightContent = {
  premium: <Fragment>
    <img
      src={rideCleanup}
      srcSet={`${rideCleanup} 1x, ${rideCleanup2x} 2x, ${rideCleanup3x} 3x`}
      alt='ride clean up' />
    <h4>Ride Clean Up</h4>
    <p>Remove bad data, join multiple rides together, or exclude portions of your ride file from your metrics. Ride cleanup tools help you make sure your data is always accurate.</p>
  </Fragment>,
  basic: <Fragment>
    <img
      src={pdfFeature}
      srcSet={`${pdfFeature} 1x, ${pdfFeature2x} 2x, ${pdfFeature3x} 3x`}
      alt='print map PDFs' />
    <h4>Print Map PDFs</h4>
    <p>Generate and print PDF files of any route and cuesheet with just a few clicks. Customize the map zoom level and cuesheet options, and get a printable PDF file in seconds. </p>
  </Fragment>
}

export const UpsellFooter = ({
  accountLevel
}) => {
  const level = accountLevel === 1 ? 'basic' : 'premium'

  return (
    <div className={styles.UpsellFooter}>
      <div className={styles.top}>
        <div className={styles.middleColumn}>
          {topContent[level]}
          <a href={'/choose_account'}>See Full Plan Comparison</a>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={styles.left}>
          {leftContent[level]}
        </div>
        <div className={styles.center}>
          {centerContent[level]}
        </div>
        <div className={styles.right}>
          {rightContent[level]}
        </div>
      </div>
    </div>
  )
}
